import React, { useEffect } from "react"

import "./index.scss"

function SuccessMessage() {
  useEffect(() => {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth

    document.body.style.overflowY = "hidden"
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`
    }
  }, [])

  return (
    <div className="success-message">
      <div className="success-message__container">
        <div>
          <h2>Estamos gerando seu boleto</h2>
        </div>
      </div>
    </div>
  )
}

export default SuccessMessage
